import * as React from "react";

import "./live-chat.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {LiveChatButton} from "./live-chat-button";

export const LiveChat = () => cs(
    consumeContext("liveChatConfig"),
    consumeContext("webchat"),
    consumeContext("company"),
    ({webchat, liveChatConfig, company}) => !webchat?.showing && company?.prefs.enableLiveChat !== false && liveChatConfig && (
        <div className="live-chat-box-85d">
            <LiveChatButton
                webchat={webchat}
                disabled={!liveChatConfig.chatEnabled}
            />
        </div>
    )
);

